import React from 'react';
import { connect } from 'react-redux';
import { validateFloat } from "../../common/validation/Validators"
import Select from 'react-select'

const NICBandRow = ({ index, currency, filteredList, nicBands, nicLettersList, disabled, updateNicBand, setNicBands, nicPeriods }) => {
    const currentIndex = nicBands?.[index]

    const RemoveButton = (span) => {
        return (<div className={`col-xs-${span || 2}`}>
            <button
                disabled={disabled}
                className='btn pull-right'
                type='button'
                style={{ marginTop: '1.25rem' }}
                onClick={() => {
                    if (disabled) return
                    nicBands.splice(index, 1)
                    setNicBands(nicBands)
                }}
            >
                <div style={{ float: "left" }}>Remove</div>
            </button>
        </div>)
    }

    return (
        <div className="col-xs-12">
            <div className="col-xs-2 pl-0 pr-0">
                <div className='form-material form-container'>
                    <label >Band</label>
                    <Select
                        value={filteredList?.find(item => item.value === currentIndex?.band)}
                        isDisabled={disabled}
                        onChange={(selected) => {
                            updateNicBand({ index, band: selected?.value || null })
                        }}
                        options={filteredList}
                    />
                </div>
            </div>
            <div className={`col-xs-${nicPeriods?.length > 0 ? 1 : 2} pl-0 pr-0`}>
                <div className='form-material form-container'>
                    <label >Letter</label>
                    <Select
                        value={nicLettersList?.find(item => item.value === currentIndex?.letter)}
                        isDisabled={disabled}
                        onChange={(selected) => {
                            updateNicBand({ index, letter: selected?.value || null })
                        }}
                        options={nicLettersList}
                    />
                </div>
            </div>
            {nicPeriods?.length > 0 ? <>
                <div className="col-xs-2 pl-0">
                    <div className='form-material form-container'>
                        <label >Period</label>
                        <Select
                            value={nicPeriods?.find(item => item.value === currentIndex?.nicPeriod)}
                            isDisabled={disabled}
                            onChange={(selected) => {
                                updateNicBand({ index, nicPeriod: selected?.value || null })
                            }}
                            options={nicPeriods}
                        />
                    </div>
                </div>
            </> : null}
            <div className="col-xs-2 pl-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Income</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.income}
                        onChange={(e) => {
                            updateNicBand({ index, income: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-2 pl-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Paid by Employee</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.paidEE}
                        onChange={(e) => {
                            updateNicBand({ index, paidEE: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-2 pl-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Paid by Employer</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.paidER}
                        onChange={(e) => {
                            updateNicBand({ index, paidER: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <RemoveButton span={nicPeriods?.length > 0 ? 1 : 2} />
        </div>
    )

}


const mapStateToProps = (state, ownProps) => {

    return {
        currency: state.company?.settings?.currency,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(NICBandRow);

